import axios from "axios";

export const client = axios.create({ baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`, withCredentials: true });

let refreshPromise = null;
client.interceptors.response.use(
  r => r,
  error => {
    const { config, response } = error;
    const skipRefresh = config?.url?.startsWith("/auth/refresh") || config?.url?.startsWith("/auth/login");
    if (response?.status === 401 && config && !config._retried && !skipRefresh) {
      config._retried = true;
      refreshPromise = refreshPromise || client.post("/auth/refresh").catch(e => { refreshPromise = null; throw e; }).then(r => { refreshPromise = null; return r; });
      return refreshPromise
        .then(() => client(config))
        .catch(e => { window.dispatchEvent(new Event("session-expired")); return Promise.reject(error); });
    }
    return Promise.reject(error);
  }
);

export const apiError = e => { const d = e.response?.data?.detail; return Array.isArray(d) ? d.map(x => x.msg).join(" ") : d || "Terjadi kesalahan"; };

export const fileUrl = id => `${process.env.REACT_APP_BACKEND_URL}/api/files/${id}`;

export const initials = name => {
  const t = (name || "?").trim();
  return (t[0] || "?").toUpperCase();
};

export const localISODate = (d = new Date()) => {
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${y}-${m}-${day}`;
};

export const isDueReached = (dueDate, { done = false, cancelled = false } = {}) =>
  !!dueDate && !done && !cancelled && dueDate <= localISODate();

const PALETTE = ["#4F46E5", "#3730A3", "#1E293B", "#4338CA", "#0F172A", "#6366F1", "#312E81", "#334155"];
export const avatarColor = seed => { let h = 0; for (const c of String(seed)) h = (h * 31 + c.charCodeAt(0)) >>> 0; return PALETTE[h % PALETTE.length]; };

export const isImageFile = filename => /\.(png|jpe?g|gif|webp|bmp|svg)$/i.test(filename || "");

export const formatSize = bytes => { if (!bytes) return "0 B"; if (bytes < 1024) return `${bytes} B`; if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`; return `${(bytes / 1024 / 1024).toFixed(1)} MB`; };

export const timeAgo = iso => {
  if (!iso) return "";
  const diff = (Date.now() - new Date(iso).getTime()) / 1000;
  if (diff < 60) return "baru saja";
  if (diff < 3600) return `${Math.floor(diff / 60)} menit yang lalu`;
  if (diff < 86400) return `${Math.floor(diff / 3600)} jam yang lalu`;
  if (diff < 2592000) return `${Math.floor(diff / 86400)} hari yang lalu`;
  return new Date(iso).toLocaleDateString("id-ID", { day: "numeric", month: "short", year: "numeric" });
};

export const shortDate = iso => {
  if (!iso) return "";
  const d = iso.length <= 10 ? new Date(`${iso}T12:00:00`) : new Date(iso);
  if (Number.isNaN(d.getTime())) return "";
  return d.toLocaleDateString("id-ID", { day: "numeric", month: "short" });
};

export const LABEL_COLORS = ["#2879ed", "#20a76a", "#ec9a2b", "#dc6863", "#8b5cf6", "#0ea5a3", "#f2617a"];

export const MIN_NEW_PASSWORD_LENGTH = 6;

export const safeHttpUrl = value => {
  const s = String(value || "").trim();
  if (!s || /[\u0000-\u001f]/.test(s)) return "";
  try {
    const u = new URL(s);
    if ((u.protocol === "http:" || u.protocol === "https:") && u.hostname) return u.href;
  } catch { /* ignore invalid */ }
  return "";
};

export const attachmentHref = item => {
  if (item?.url) return safeHttpUrl(item.url);
  const id = item?.id || item?.file_id;
  return id ? fileUrl(id) : "";
};
